import Scrollbar from './vendor/smooth-scrollbar';
import Plyr from './vendor/plyr.polyfilled.mjs';

export default function(args) {
  var scrollbar=Scrollbar.init($('.scroll-container')[0], {
  });
  window.appScrollbar=scrollbar;
  var $window=$(window);

  $(".pil-content.avp2>ul").addClass("pin-list").find(">li").attr("data-anim", "moveup");
  $(".job-content>*, .jobfeature-lists li").attr("data-anim", "moveup");
  $(".logo a").attr("href", "/");
  
  
  
  
  var scrollMoveEls=$("[data-scrollmove]");
  scrollbar.addListener((status)=>{
    for(var i=0;i<scrollMoveEls.length;i++) {
      var el=scrollMoveEls.eq(i);
      var multiplier=el.attr("data-scrollmove")*1;
      var offset=el.closest("section").offset().top;
      if ($window.innerWidth()<750)
        el.css("transform", "");
      else
        el.css("transform", "translateY("+(-offset*multiplier)+"px)");
    }
  });
  
  var scrollMoveEls2=$("[data-scrollmove2]");
  scrollbar.addListener((status)=>{
    for(var i=0;i<scrollMoveEls2.length;i++) {
      var el=scrollMoveEls2.eq(i);
      var multiplier=el.attr("data-scrollmove2")*1;
      var offset=el.offset().top-window.innerHeight*0.3;
      if ($window.innerWidth()<750)
        el.css("transform", "");
      else
        el.css("transform", "translateY("+(-offset*multiplier)+"px)");
    }
  });
  
  $("aside.nav").each(function() {
    var $this=$(this);
    var $parent=$this.closest("section, .hiring-dark");
    var asideNavListener=(status)=>{
      var parentTop=$parent.offset().top;
      $this.css("top", -parentTop);
    };
    scrollbar.addListener(asideNavListener);
    $(window).on("resize", asideNavListener).on("load", asideNavListener);
    asideNavListener();
    setTimeout(asideNavListener, 200);
  });
  
  var animEls=$("[data-anim]");
  animEls.each(function() {
    var el=$(this);
    var anim=el.attr("data-anim");
    if (anim=="words") (function() {
      var elHtml=el.html().split(" ");
      el.addClass("to-anim");
      el.html("");
      for(var i in elHtml) {
        var span=$("<span />", {html: "<span>"+elHtml[i]+"</span>", class: "anim-words to-anim"});
        el.append(span);
        el.append(" ");
      }
    })();
    if (anim=="one") (function() {
      var elHtml=[el.html()];
      el.addClass("to-anim");
      el.html("");
      for(var i in elHtml) {
        var span=$("<span />", {html: "<span>"+elHtml[i]+"</span>", class: "anim-one to-anim"});
        el.append(span);
        el.append(" ");
      }
    })();
    if (anim=="moveup") (function() {
      el.addClass("anim-moveup to-anim start-anim");
    })();
    if (anim=="moveup2") (function() {
      el.addClass("anim-moveup2 to-anim start-anim");
    })();
    if (anim=="fromleft") (function() {
      el.addClass("anim-fromleft to-anim start-anim");
    })();
    if (anim=="fromright") (function() {
      el.addClass("anim-fromright to-anim start-anim");
    })();
    if (anim=="secnav") (function() {
      el.addClass("anim-secnav to-anim start-anim");
    })();
    if (anim=="zoomout") (function() {
      el.wrap("<span class=\"anim-imgzoom to-anim\" />");
      el.wrap("<span />");
      el.addClass("to-anim");
    })();
  });
  var animQueue=[];
  animQueue.addNext=function(span, parent) {
    animQueue.push({span, parent});
    if (animQueue.length==1)
      animQueue.doNext();
  }
  animQueue.doNext=function() {
    var el=animQueue[0];
    setTimeout(()=>el.span.removeClass("to-anim start-anim").addClass("end-anim"), 200);
    setTimeout(()=>el.span.removeClass("end-anim"), 1200);
    var hasParentHidden=false;
    var parentEl=el.span.parent();
    while(parentEl && parentEl.length && parentEl[0].tagName!="HTML") {
      if (parentEl.css("display")=="none")
        hasParentHidden=true;
      parentEl=parentEl.parent();
    }
    setTimeout(()=>{
      animQueue.shift();
      if (animQueue.length)
        animQueue.doNext();
    }, hasParentHidden?1:100);
  }
  var animListener=(status)=>{
    var windowHeight=$window.innerHeight();
    for(var i=0;i<animEls.length;i++) {
      let el=animEls.eq(i);
      if (!el.hasClass("to-anim"))
        continue;
      var top=el.offset().top;
      if (top<=windowHeight) {
        el.removeClass("to-anim");
        if (el.parent().parent().hasClass("anim-imgzoom")) {
          animQueue.addNext(el.parent().parent(), el);
        } else if (el.hasClass("anim-moveup") ||
                   el.hasClass("anim-moveup2") ||
                   el.hasClass("anim-fromleft") ||
                   el.hasClass("anim-fromright") ||
                   el.hasClass("anim-secnav")) {
          animQueue.addNext(el, el);
        } else {
          el.find(">span").each(function(index) {
            animQueue.addNext($(this), el);
          });
        }
      }
    }
  }
  scrollbar.addListener(animListener);
  var animTimeout=setTimeout(animListener, (args && args.immediate || !$(".loading-video").length)?300:7200);
  $(".loading-video video")[0] && $(".loading-video video")[0].addEventListener("ended", ()=>{
    clearTimeout(animTimeout);
    animListener();
  });

  
  var scrollWidget=$(".scroll-notify");
  var scrollWidgetI=scrollWidget.find("i");
  var scrollWidgetAnim=function(status) {
    var progress=status?(status.offset.y/status.limit.y):0;
    if (progress<0.01) {
      scrollWidget.removeClass("scroll-notify-done");
      scrollWidget.addClass("scroll-notify-anim");
      scrollWidgetI.css("height", "");
    } else if (progress>0.99 && window.innerWidth<=760) {
      scrollWidget.removeClass("scroll-notify-anim");
      scrollWidget.addClass("scroll-notify-done");
      scrollWidgetI.css("height", Math.round(progress*100)+"%");
    } else {
      scrollWidget.removeClass("scroll-notify-anim");
      scrollWidget.removeClass("scroll-notify-done");
      scrollWidgetI.css("height", Math.round(progress*100)+"%");
    }
  }
  scrollbar.addListener(scrollWidgetAnim);
  scrollWidgetAnim();
  
  scrollWidget.click(function(e) {
    scrollbar.scrollTo(0, 0, 500);
  });
  
  scrollbar.addListener((status)=>{
    if (window.methodologyEl) {
      if ($(window.methodologyEl.$el).offset().top<window.innerHeight)
        if (!window.methodologyEl.alreadyStarted) {
          window.methodologyEl.alreadyStarted=true;
          window.methodologyEl.startAnim();
        }
    }
  });
  
  
  var stickyEls=[];
  $("[data-sticky]").each(function() {
    stickyEls.push({el: $(this), parent: $(this).parent(), zw: $(this).closest(".zoom-wrapper")});
  });
  scrollbar.addListener((status)=>{
    for(var item of stickyEls) {
      var itemTop=item.el.offset().top;
      var parentTop=item.parent.offset().top;
      var parentHeight=item.parent.innerHeight();
      var itemHeight=item.el.innerHeight();
      var trTop=0;
      if (parentTop<item.el.attr("data-sticky")*1)
        trTop=item.el.attr("data-sticky")*1-parentTop;
      var zoomScale=1500/(item.zw.length?item.zw.innerWidth() || 1500:1500);
      trTop*=zoomScale;
      if (trTop>parentHeight-itemHeight)
        trTop=parentHeight-itemHeight;
      if ($window.innerWidth()<=750)
        item.el.css("transform", "");
      else
        item.el.css("transform", "translateY("+trTop+"px)");
    }
  });
  
  var stickyEls2=[];
  $("[data-sticky2]").each(function() {
    stickyEls2.push({el: $(this), parent: $(this).parent(), zw: $(this).closest(".zoom-wrapper")});
  });
  var stickyElListener2=(status)=>{
    for(var item of stickyEls2) {
      var itemTop=item.el.offset().top;
      var parentTop=item.parent.offset().top;
      var parentHeight=item.parent.innerHeight();
      var itemHeight=item.el.innerHeight();
      var trTop=0;
      if (parentTop<item.el.attr("data-sticky2")*1)
        trTop=item.el.attr("data-sticky2")*1-parentTop;
      var zoomScale=1500/(item.zw.length?item.zw.innerWidth() || 1500:1500);
      trTop*=zoomScale;
      if ($window.innerWidth()<=750) {
        var sectionHeight=item.parent.closest("section").innerHeight();
        var sectionTop=item.parent.closest("section").offset().top;
        zoomScale=390/(item.zw.length?item.zw.innerWidth() || 390:390);
        trTop=(sectionHeight-itemHeight-parentTop-62)*zoomScale;
      }
      item.el.css("transform", "translateY("+trTop+"px)");
    }
  }
  scrollbar.addListener(stickyElListener2);
  stickyElListener2();
  
  var stickyEls3=[];
  $("[data-sticky3]").each(function() {
    stickyEls3.push({el: $(this), parent: $(this).parent(), zw: $(this).closest(".zoom-wrapper")});
  });
  var stickyElListener3=(status)=>{
    for(var item of stickyEls3) {
      var itemTop=item.el.offset().top;
      var parentTop=item.parent.offset().top;
      var parentHeight=item.parent.innerHeight();
      var itemHeight=item.el.innerHeight();
      var trTop=0;
//       if (parentTop<item.el.attr("data-sticky3")*1)
        trTop=item.el.attr("data-sticky3")*1-parentTop;
      var zoomScale=1500/(item.zw.length?item.zw.innerWidth() || 1500:1500);
      trTop*=zoomScale;
      if ($window.innerWidth()<=750) {
        var sectionHeight=window.innerHeight;
        var sectionTop=item.parent.closest("section").offset().top;
        zoomScale=390/(item.zw.length?item.zw.innerWidth() || 390:390);
        trTop=(sectionHeight-itemHeight-parentTop-13)*zoomScale;
      }
      item.el.css("transform", "translateY("+trTop+"px)");
    }
  }
  scrollbar.addListener(stickyElListener3);
  stickyElListener3();

  var animImgs=$("img[data-anim=zoomout]");
  scrollbar.addListener((status)=>{
    var windowHeight=$(window).innerHeight();
    animImgs.each(function(index) {
      if ($(this).parent().parent().hasClass("to-anim") || $(this).parent().parent().hasClass("end-anim"))
        return;
      var top=$(this).offset().top;
      var pos=top/windowHeight;
      var zoom=Math.min(1.3, Math.max(1, 1.1+pos*0.15));
      $(this).css("transform", "scale("+zoom+")").css("transition", ".3s transform ease-out");
    });
  });


  if (!args || args.transition!='product') {
    $("aside.nav").addClass("to-anim");
    var navAnim=function() {
      $("aside.nav").removeClass("to-anim").addClass("end-anim");
      setTimeout(()=>$("aside.nav").removeClass("end-anim"), 2500);
    }
    setTimeout(navAnim, (args && args.immediate)?500:7500);
  } else {
  }
  
  $(".applybtn").hover(function(e) {
    $(".applybtn").addClass("hover");
  }, function(e) {
    $(".applybtn").removeClass("hover");    
  });

  
  
  
  var scrollContainers2=$(".news-list ul, ul.news-list:not(.not-slider), .newscat-list ul, .team-list");
  scrollContainers2.each(function() {
    var $el=$(this).css("overflow", "visible");
    $el.wrap("<div class=\"inner-scroll\" />");
    $el=$el.parent();
    var scrollbar=Scrollbar.init($el[0], {
    });
    this.appScrollbar=scrollbar;
  });

  scrollContainers2=$(".news-list ul, ul.news-list:not(.not-slider), .newscat-list ul, .team-list");
  scrollContainers2.each(function() {
    var container=$(this);

    const desktopOnly = this.classList.contains('desktop');

    var slideBox=$("<div />", {class: `slide-box mob-only ${desktopOnly && 'desktop'}` }).insertAfter(container.closest(".inner-scroll"));
    var slideBar=$("<div />", {class: "slide-bar"}).appendTo(slideBox);
    var slideBarIn=$("<span />").appendTo(slideBar);
    var slideLabel=$("<label>", {html: "Slide"}).appendTo(slideBox);
    var scrollBar=this.appScrollbar;
    scrollBar.addListener((status)=>{
      var outWidth=this.clientWidth;
      var contWidth=scrollBar.limit.x+outWidth;
      var scLeft=scrollBar.offset.x;
      var width=outWidth/contWidth*100;
      var left=scLeft/contWidth*100;
      slideBarIn.addClass("scrolled").css("margin-left", left+"%").css("width", width+"%");      
    });
    var outWidth=this.clientWidth;
    var contWidth=scrollBar.limit.x+outWidth;
    var width=outWidth/contWidth*100;
    slideBarIn.css("width", width+"%");      
    container.off("scroll").on("scroll", function() {
      var outWidth=this.clientWidth;
      var contWidth=this.scrollWidth;
      var scLeft=this.scrollLeft;
      var width=outWidth/contWidth*100;
      var left=scLeft/contWidth*100;
      slideBarIn.css("margin-left", left+"%").css("width", width+"%");
    }).trigger("scroll");
  });
  
  
  
  
  $("video[data-imgfallback]").each(function() {
    $(this).on("error aborted", function(e) {
      console.log(e);
      $(this).find("img").unwrap();
    });
  });
  
  $(".pli-img-list .video").click(function(e) {
    var video=$(this).addClass("playing").find("video")[0];
    video.play();
    video.controls=true;
  });
  
  $(".play-trailer").click(function(e) {
    e.preventDefault();
    $(this).hide().parent().find("em").hide();
    $(".video-popup").remove();
//     var $pop=$("<div />", {class: "video-popup"}).appendTo("body");
//     var $outer=$("<div />", {class: "pop-ct"}).appendTo($pop);
//     var $inner=$("<div />", {class: "pop-in"}).appendTo($outer);
//     var $close=$("<a />", {class: "close", html: "&times;"}).appendTo($inner).click(function(e) {
//       e.preventDefault();
//       $pop.removeClass("visible");
//       setTimeout(()=>$pop.remove(), 300);
//     });
    var $videoOuter=$("<div />", {class: "plyr__video-embed"})/*.appendTo($inner)*/;
    $(this).parent().find("video").replaceWith($videoOuter);
    var $video=$("<iframe />", {allowfullscreen: "allowfullscreen", src: this.href+"?autoplay=1"}).appendTo($videoOuter);
//     setTimeout(()=>$pop.addClass("visible"), 30);
//     $pop.click(function(e) { $close.click(); });
//     $inner.click(function(e) { e.stopPropagation(); });
    new Plyr($videoOuter[0]);
  });
  
  $("div.hiring-img, video.hiring-img, .pli-img-list video").each(function() {
    new Plyr(this, {
    });
  });
  
  
  $("img[data-introvid]").each(function() {
    var video=$("<video />", {
      src: $(this).attr("data-introvid"),
      loop: "loop",
      autoplay: "autoplay",
      class: "introvid",
      "webkit-playsinline": "webkit-playsinline",
      playsinline: "playsinline",
    });
    $(this).after(video);
  });
  
}
